import React from 'react'
import CardBlog from '../Other/CardBlog'
import { NavLink } from 'react-router-dom'

const SecBlog = () => {
    const blogData = [
    {
        tag: "Zimmerpflanzen",
        bg: "./../images/potted.jpg",
        title: "Topfpflanzen - Große Auswahl an Zimmer- und Balkonpflanzen",
        name: "WeroFlowers",
        profile: "./../images/potted.jpg",
        date: "2025",
    },
    {
        tag: "Garten",
        bg: "./../images/garden.jpg",
        title: "Gartenpflanzen & Bäumchen - Bäume, Sträucher und mehrjährige Pflanzen",
        name: "WeroFlowers",
        profile: "./../images/logo.svg",
        date: "2025",
    },
    {
        tag: "Anbau",
        bg: "./../images/bulbs.jpg",
        title: "Samen und Zwiebeln - Hochwertige Samen für Blumen, Gemüse und Kräuter",
        name: "WeroFlowers",
        profile: "./../images/logo.svg",
        date: "2025",
    },
    {
        tag: "Zubehör",
        bg: "./../images/donice-kategoria.webp",
        title: "Töpfe und Übertöpfe - Stilvolle Töpfe in verschiedenen Größen und Farben",
        name: "WeroFlowers",
        profile: "./../images/logo.svg",
        date: "2025",
    },
    {
        tag: "Pflege",
        bg: "./../images/soil-fertilizers.jpg",
        title: "Erde und Dünger - Spezialsubstrate und organische Düngemittel",
        name: "WeroFlowers",
        profile: "./../images/logo.svg",
        date: "2025",
    },
    {
        tag: "Dekoration",
        bg: "./../images/christmas-decorations.jpg",
        title: "Tannenbäume und Dekorationen - Frische Weihnachtsbäume und Saisondeko",
        name: "WeroFlowers",
        profile: "./../images/logo.svg",
        date: "2025",
    },
]
    return (
        <section id="blog">
            <div className="container">
                <div className="text-center mb-5">
                    <h2 className="normal font__size--50 text__50-1024 text__50-sm text__50-xs">Gartencenter Duisburg <br />Pflanzen & Gartenzubehör</h2>
                    <p className="normal font__size--14 text__14-1024 color__gray-1">Entdecken Sie hochwertige Zimmerpflanzen, Gartenpflanzen, Samen und Gartenzubehör in unserem Gartencenter in Duisburg. Fachberatung und große Auswahl für Hobbygärtner und Pflanzenliebhaber.</p>
                </div>

                <div className="row mb-5">
                    {
                        blogData.map((obj) => {
                            return <div className="col-md-6 mb-4 col-lg-4">
                                <CardBlog data={obj} />
                            </div>
                        })
                    }
                </div>

                {/* <div className="text-center">
                    <NavLink to="/blog" className="medium font__size--16 text__16-1024 btn btn__outlined--black color__black shadow ml-3 no__opacity h__white rounded__50 pointer d-inline-block">Explore More</NavLink>
                </div> */}
            </div>
        </section>
    )
}

export default SecBlog